export default "__VITE_ASSET__7cfc311d__"